export const CONNECTIVITY_TARGET = 0.75
